import moment from 'moment';
import 'moment-timezone';
import { isNotNullUnDef, isNotNullUnDefNA } from './stringUtil';

export const getLocaleString = () => new Date().toLocaleString();

export const convertUTCTimeToLocaleString = (utcTime) => {
  if (utcTime) {
    return new Date(utcTime).toLocaleString();
  }

  return getLocaleString();
};

const tzmap = new Map();
tzmap.set('Asia/Amman', 'EEST');
tzmap.set('America/Caracas', 'VET');
tzmap.set('Asia/Kuwait', 'AST');
tzmap.set('America/Sao_Paulo', 'BRT');
tzmap.set('Asia/Bangkok', 'ICT');
tzmap.set('Asia/Qatar', 'AST');
tzmap.set('America/Lima', 'PET');
tzmap.set('America/Argentina/Buenos_Aires', 'ART');
tzmap.set('Asia/Kuala_Lumpur', 'MYT');
tzmap.set('America/Santiago', 'CLST');
tzmap.set('Atlantic/Stanley', 'ADT');
tzmap.set('Asia/Dhaka', 'BST');
tzmap.set('Asia/Singapore', 'SGT');

// eslint-disable-next-line max-params
const dtformat = (date, tzDbNm, includeTime = true, includeTz = true, dFormat = 'MMMM D, YYYY', tFormat = 'HH:mm:ss') => {
  // const commonDateFormat = 'MMMM D, YYYY';
  try {
    console.log('dtformat tzDbNm in function before conversion', tzDbNm);
    console.log('dtformat date in function before conversion', date);
    if (!isNotNullUnDef(tzmap.get(tzDbNm))) {
      let dateTimeFormat = includeTime ? `${dFormat} ${tFormat}` : dFormat;
      dateTimeFormat = includeTz ? `${dateTimeFormat} z` : dateTimeFormat;
      const str = date.format(dateTimeFormat);
      console.log('dtformat in side if str in function after  conversion', str);
      return str;
    }
    let str = includeTime ? date.format(`${dFormat} ${tFormat} `) : date.format(dFormat);
    console.log('dtformat from map', str);
    console.log('dtformat from map', tzmap.get(tzDbNm));
    str = includeTz ? `${str} ${tzmap.get(tzDbNm)}` : str;
    console.log('dtformat  *** out *** side if str in function after  conversion', str);
    return str;
  } catch (e) {
    console.log('dtformat in Exception', date.toString());
    return date.toString();
  }
};

const tformat = (date, tzDbNm, tFormat = 'HH:mm:ss') => {
  try {
    console.log('timeformat tzDbNm in function before conversion', tzDbNm);
    console.log('timeformat date in function before conversion', date);
    if (!isNotNullUnDef(tzmap.get(tzDbNm))) {
      const str = date.format(`${tFormat} z`);
      console.log('timeformat in side if str in function after  conversion', str);
      return str;
    }
    let str = date.format(`${tFormat} `);
    console.log('timeformat from map', str);
    console.log('timeformat from map', tzmap.get(tzDbNm));
    str += tzmap.get(tzDbNm);
    console.log('timeformat  *** out *** side if str in function after  conversion', str);
    return str;
  } catch (e) {
    console.log('timeformat in Exception', date.toString());
    return date.toString();
  }
};
export const convertDraftDateTimeStr = (tzDbNm, dateTime) => {
  try {
    // eslint-disable-next-line no-param-reassign
    if (!isNotNullUnDef(tzDbNm)) {
      // eslint-disable-next-line no-param-reassign
      tzDbNm = 'Africa/Abidjan';
    }
    if (isNotNullUnDefNA(dateTime)) {
      const userLocalTime = dtformat(moment.tz(dateTime, tzDbNm), tzDbNm);
      return userLocalTime;
    }
    return dateTime;
  } catch (e) {
    return dateTime.toString();
  }
};

// eslint-disable-next-line max-params
export const convertDateTimeStr = (tzDbNm, dateTime, includeTime = true, includeTz = true, dFormat = 'MMMM D, YYYY', tFormat = 'HH:mm:ss') => {
  try {
    // eslint-disable-next-line no-param-reassign
    if (!isNotNullUnDef(tzDbNm)) { tzDbNm = 'Africa/Abidjan'; }
    if (isNotNullUnDefNA(dateTime)) {
    // Convert DB datetime to UTC timezone
      const utcTime = moment.tz(dateTime, 'Africa/Abidjan');
      return dtformat(utcTime.clone().tz(tzDbNm), tzDbNm, includeTime, includeTz, dFormat, tFormat);
    }
    return dateTime;
  } catch (e) {
    console.log('convertDateTimeStr in Exception', dateTime.toString());
    return dateTime.toString();
  }
};

export const convertDateStr = (tzDbNm, datetoConvert) => {
  try {
    // eslint-disable-next-line no-param-reassign
    if (!isNotNullUnDef(tzDbNm)) {
      // eslint-disable-next-line no-param-reassign
      tzDbNm = 'Africa/Abidjan';
    }
    if (isNotNullUnDefNA(datetoConvert)) {
      const userDate = moment.tz(datetoConvert, tzDbNm).format('MMMM D, YYYY');
      return userDate;
    }
    return datetoConvert;
  } catch {
    return datetoConvert.toString();
  }
};

export const convertTimeStr = (tzDbNm, datetoConvert, tFormat = 'HH:mm:ss') => {
  try {
    // eslint-disable-next-line no-param-reassign
    if (!isNotNullUnDef(tzDbNm)) { tzDbNm = 'Africa/Abidjan'; }
    if (isNotNullUnDefNA(datetoConvert)) {
      const utcTime = moment.tz(datetoConvert, 'Africa/Abidjan');
      const userTime = tformat(utcTime.clone().tz(tzDbNm), tzDbNm, tFormat);
      return userTime;
    }
    return datetoConvert;
  } catch {
    return datetoConvert.toString();
  }
};

export const convertToUserTZDateStr = (tzDbNm, datetoConvert) => {
  try {
    // eslint-disable-next-line no-param-reassign
    if (!isNotNullUnDef(tzDbNm)) { tzDbNm = 'Africa/Abidjan'; }
    if (isNotNullUnDefNA(datetoConvert)) {
    // Convert DB datetime to UTC timezone
      const utcTime = moment.tz(datetoConvert, 'Africa/Abidjan');
      const userDate = utcTime.clone().tz(tzDbNm).format('MMMM D, YYYY');
      return userDate;
    }
    return datetoConvert;
  } catch {
    return datetoConvert.toString();
  }
};

export const convertToUserTZTimeStr = (tzDbNm, datetoConvert) => {
  try {
    // eslint-disable-next-line no-param-reassign
    if (!isNotNullUnDef(tzDbNm)) { tzDbNm = 'Africa/Abidjan'; }
    if (isNotNullUnDefNA(datetoConvert)) {
    // Convert DB datetime to UTC timezone
      const utcTime = moment.tz(datetoConvert, 'Africa/Abidjan');
      const userTime = tformat(utcTime.clone().tz(tzDbNm), tzDbNm);
      return userTime;
    }
    return datetoConvert;
  } catch {
    return datetoConvert.toString();
  }
};

export const getFormattedData = (data) => {
  if (typeof data === 'string' || data !== 'NA') {
    const isDate = data?.match(/\d{4}-[01]\d-[0-3]\dT[0-2](?:\d:[0-6]){2}\d/);
    if (isDate) {
      const tempDate = new Date(data);
      return `${tempDate.toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })} ${data.split('T')[1]?.split('.')[0]} UTC`;
    }
  }
  return data;
};

export const getFormattedDate = (data) => {
  if (typeof data === 'string' || data !== 'NA') {
    const isDate = data?.match(/\d{4}-[01]\d-[0-3]\dT[0-2](?:\d:[0-6]){2}\d/);
    if (isDate) {
      const tempDate = new Date(data);
      return `${tempDate.toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })} ${data.split('T')[1]?.split('.')[0]} UTC`;
    }
  }
  return data;
};
